











































































































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import PaymentState from '@/components/Accounts/Shared/Payments/PaymentState.vue';
import PaymentCancel from '@/components/Accounts/Shared/Payments/PaymentCancel.vue';
import PaymentsFilterDialog from '@/components/Accounts/Shared/Payments/PaymentsFilterDialog.vue';
import PaymentStateModel from '@/models/Accounts/Shared/Payments/PaymentState';
import Payment from '@/models/Accounts/Shared/Payments/Payment';
import ScheduleFrequency from '@/models/Shared/ScheduleFrequency';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'Payments', components: { PaymentState, PaymentCancel, PaymentsFilterDialog } })
export default class extends SaascadaVue {

    @Prop({required: true})
    isCustomerAccount: boolean;

    PaymentStateModel = PaymentStateModel;
    ScheduleFrequency = ScheduleFrequency;

    headers = [
        { text: this.$t('pageText.depositAccounts.fields.payeeName'), width: "25%", sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.reference'), width: "30%", sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.amount'), width: "25%", sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.state'), width: "20%", sortable: false },
    ];
    paymentsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.paymentsPage = +page;
        }
    }

    async beforeMount() {
        if (this.isCustomerAccount) {
            await DepositAccountModule.getPayments(this.paymentsPage);
        }
        else {
            await InstitutionAccountModule.getPayments({ id: this.$route.params.id, pageNumber: this.paymentsPage });
        }
    }

    @Watch('paymentsPage')
    async onPaymentsPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.paymentsPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.paymentsPage}` } });
        }
        // Get new payments
        if (this.isCustomerAccount) {
            await DepositAccountModule.getPayments(this.paymentsPage);
        }
        else {
            await InstitutionAccountModule.getPayments({ id: this.$route.params.id, pageNumber: this.paymentsPage });
        }
    }

    get payments() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.payments;
        }
        else {
            return InstitutionAccountModule.payments;
        }
    }

    get totalPaymentsPages() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.totalPaymentsPages;
        }
        else {
            return InstitutionAccountModule.totalPaymentsPages;
        }
    }

    get filterByPaymentState() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.filterByPaymentState;
        }
        else {
            return InstitutionAccountModule.filterByPaymentState;
        }
    }

    get pageSize() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.pageSize;
        }
        else {
            return InstitutionAccountModule.pageSize;
        }
    }

    get loadingPayments() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.loadingPayments;
        }
        else {
            return InstitutionAccountModule.loadingPayments;
        }
    }

    get showPaymentMetadata() {
        if (this.currentPayment.metadata) {
            return Object.keys(this.currentPayment.metadata).length !== 0;
        }
        else {
            return false;
        }
    }

    get showTransactionMonitoring() {
        if (this.currentPayment.transactionMonitoring) {
            return Object.keys(this.currentPayment.transactionMonitoring).length !== 0;
        }
        else {
            return false;
        }
    }

    async updateCurrentPayment(payment: Payment) {
        if (this.isCustomerAccount) {
            await DepositAccountModule.updateCurrentPayment(payment);
        }
        else {
            await InstitutionAccountModule.updateCurrentPayment(payment);
        }
    }

    get currentPayment() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.currentPayment;
        }
        else {
            return InstitutionAccountModule.currentPayment;
        }
    }

    get allowCancelPayment() {
        // Note that this scenario only applies to customer accounts and institution payments cannot be cancelled
        if (this.isCustomerAccount) {
            const isScheduledPayment = this.currentPayment.state === PaymentStateModel.Scheduled;
            const isToggleEnabled = PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.CancelPayments);
            return isScheduledPayment && isToggleEnabled;
        }
        else {
            return false;
        }
    }

}
